import { useEffect, useState } from 'react';
import { useAppAuth } from '../components/AuthContext.jsx';
import { getProgress } from '../api/core.js';
import { usePolicy } from '../components/PolicyContext.jsx';

export default function Journey() {
  const { policy } = usePolicy();
  const { user } = useAppAuth();
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(null);
  useEffect(() => {
    let active = true;
    getProgress().then((data) => { if (active) setProgress(data); })
      .catch((err) => {
        if (active) setError(err.response?.data?.error || err.message || 'Cestu se nepodařilo načíst.');
      });
    return () => { active = false; };
  }, []);
  const stageIndex = progress
    ? progress.makler.is_newcomer ? 0 : Number(progress.makler.level_numeric)
    : null;

  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <h1 className="dashboard__title">Moje cesta</h1>
      </div>

      {error && <p className="dashboard__error" role="alert">{error}</p>}
      {!progress && !error && <p className="dashboard__status">Načítá se…</p>}

      <p className="dashboard__lead">
        Vývojové úrovně, milníky a příští kroky na vaší cestě Rozjezdem.
      </p>

      <article className="card">
        <h2 className="card__title">Profil</h2>
        <dl className="journey__profile">
          <div>
            <dt>Jméno</dt>
            <dd>{user?.full_name || '—'}</dd>
          </div>
          <div>
            <dt>Role</dt>
            <dd>{user?.role || '—'}</dd>
          </div>
          <div>
            <dt>Pozice</dt>
            <dd>{user?.position || '—'}</dd>
          </div>
          <div>
            <dt>Status</dt>
            <dd>{progress?.makler.status_label || user?.status || '—'}</dd>
          </div>
        </dl>
      </article>

      <h2 style={{ fontSize: 'var(--cs-fs-h4)', margin: 'var(--cs-s10) 0 var(--cs-s6)' }}>
        Milníky cesty
      </h2>

      <ol className="journey__stages">
        {progress && policy.levels.map((stage, i) => (
          <li
            key={stage.numeric}
            className={`journey__stage ${i === stageIndex ? 'journey__stage--current' : ''} ${
              i < stageIndex ? 'journey__stage--done' : ''
            }`}
          >
            <span className="journey__stage-mark">{i < stageIndex ? '✓' : i + 1}</span>
            <div className="journey__stage-body">
              <h3 className="journey__stage-title" style={{ color: stage.color }}>{stage.name}</h3>
              {i === stageIndex && <p className="journey__stage-desc">Aktuálně přiřazená úroveň</p>}
            </div>
          </li>
        ))}
      </ol>
      {progress && (
        <article className="card">
          <h2 className="card__title">Cíle a tempo</h2>
          <p>Tempo: {Number(progress.tempo?.annual_czk || 0).toLocaleString('cs-CZ')} Kč / rok</p>
          <p>Cíl prvního roku: {Number(progress.goals.annualTempo).toLocaleString('cs-CZ')} Kč / rok</p>
          <p>Provize za 12 měsíců: {Number(progress.tempo?.commission_12m || 0).toLocaleString('cs-CZ')} Kč
            {' · '}laťka samostatnosti: {Number(progress.goals.independenceCommission).toLocaleString('cs-CZ')} Kč</p>
          {progress.makler.is_newcomer && <p>Kontakty ke zkoušce: {progress.makler.total_calls} / {progress.makler.contacts_goal}.
            {' '}Je to cíl, ne podmínka složení zkoušky.</p>}
        </article>
      )}
      {progress && (
        <article className="card">
          <h2 className="card__title">Zaznamenané milníky</h2>
          {progress.milestones.length === 0 ? (
            <p className="card__text">Zatím žádné zaznamenané milníky.</p>
          ) : (
            <ul className="card__text">
              {progress.milestones.map((milestone) => (
                <li key={milestone.id}>
                  {milestone.title || milestone.milestoneType || milestone.milestone_type}
                  {milestone.type_label && <> · {milestone.type_label}</>}
                  {' · '}{milestone.status}
                </li>
              ))}
            </ul>
          )}
        </article>
      )}
    </section>
  );
}
